/**
 * Zapamätaný `search` zoznamu, aby sa cesta späť vrátila k tomu istému výberu.
 *
 * Filtre, hľadanie, zoradenie aj strana žijú v adrese zoznamu
 * ([zoznamy.md](../../.docs/vyvoj/zoznamy.md)), lenže cesta späť z detailu je
 * statická - `backPath` na `RouteMetadata` aj `href` článku cesty poznajú len
 * holú cestu zoznamu. Šípka späť tým zoznam otvorila odznova a všetko
 * nastavené sa stratilo. Zoznam si preto pri každej zmene adresy odloží svoj
 * `search` a detail ho k ceste späť pripojí.
 *
 * Odkladá sa do `sessionStorage`, nie do premennej modulu: prežije obnovenie
 * stránky detailu aj cmd-klik do novej karty (tá si `sessionStorage`
 * otvárajúcej kopíruje), takže filtre nájde aj podnet otvorený vedľa. A
 * neprežije zavretie karty, takže výber spred týždňa sa nikomu nevynorí.
 *
 * Prístup je v `try`: v privátnom režime niektorých prehliadačov `sessionStorage`
 * hodí výnimku a stratený filter nie je dôvod zhodiť stránku.
 */
const key = (path: string) => `list-search:${path}`;

/** Zavolá zoznam pri každej zmene svojej adresy; prázdny `search` je platná hodnota. */
export const rememberListSearch = (path: string, search: string) => {
  try {
    sessionStorage.setItem(key(path), search);
  } catch {
    /* privátny režim - filter sa nezapamätá, nič viac */
  }
};

/** Cesta na zoznam aj s naposledy videným výberom. Bez neho vráti holú cestu. */
export const listPathWithSearch = (path: string) => {
  try {
    return `${path}${sessionStorage.getItem(key(path)) ?? ''}`;
  } catch {
    return path;
  }
};
